import { FormType } from '@gearbelt/global';

import { AWAFormPage } from '../form';

export function AWASchedulePage() {
  return <AWAFormPage formType={FormType.ScheduleForm} />;
}
